import { render, staticRenderFns } from "./ConversationHistoryItem.vue?vue&type=template&id=318db516&"
import script from "./ConversationHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ConversationHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports